var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_\\uCABD\\uC9C0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_34",
    "data-name": "\\uC0AC\\uAC01\\uD615 34",
    width: 18,
    height: 18,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_69",
    "data-name": "\\uADF8\\uB8F9 69",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_37",
    "data-name": "\\uD328\\uC2A4 37",
    d: "M12.937,4a1.312,1.312,0,0,1,.787,2.362l-.379.286a4.807,4.807,0,0,0-4,3l-1.57,1.176a.878.878,0,0,1-1.051,0L.775,6.364A1.312,1.312,0,0,1,1.562,4ZM8.3,11.526l.721-.541c-.013.151-.021.3-.021.455A4.8,4.8,0,0,0,10.1,14.5H2a1.75,1.75,0,0,1-1.75-1.75V7.065L6.2,11.526a1.743,1.743,0,0,0,2.1,0m9.45-.086A3.938,3.938,0,1,1,13.812,7.5,3.939,3.939,0,0,1,17.75,11.44m-2.715-1.185-1.66,1.66-.785-.785a.437.437,0,0,0-.618.619l1.094,1.094a.433.433,0,0,0,.617,0l1.969-1.969a.437.437,0,1,0-.617-.619",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon_쪽지.ab022a192b95876f7ee0fb87ee3beafe.svg";
export { ForwardRef as ReactComponent };